export class LeaderOwnerModel{
    public owner:string;
 
    constructor(owner:string){
        this.owner=owner;
        
    }

}